function enableKeyboardClick(selector) {
  // Apply behavior to an element
  console.log('enableKeyboardClick', selector);
  const apply = (el) => {
    if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '0');
    }

    // Add keydown event only once
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        el.click();
      }
    });
  };

  // Initial scan for existing elements
  document.querySelectorAll(selector).forEach(apply);

  // Observe DOM changes for future elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Direct match
          if (node.matches(selector)) {
            apply(node);
          }
          // Nested matches
          node.querySelectorAll?.(selector).forEach(apply);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

enableKeyboardClick('body .gbbExtBundleRedirectButton');